import { createFileRoute } from "@tanstack/react-router";
import { z } from "zod";

import { InstagramCallbackPage } from "@/components/Pages/Instagram";
import {
  INSTAGRAM_CALLBACK_FAILURE_REASONS,
  INSTAGRAM_CALLBACK_STATUSES,
} from "@/lib/instagram/constants";

const instagramCallbackSearchSchema = z.object({
  status: z.enum(INSTAGRAM_CALLBACK_STATUSES).optional().catch(undefined),
  reason: z.enum(INSTAGRAM_CALLBACK_FAILURE_REASONS).optional().catch("unknown"),
  store_id: z.coerce.number().int().positive().optional().catch(undefined),
  username: z.string().optional(),
});

export const Route = createFileRoute("/instagram/callback")({
  validateSearch: instagramCallbackSearchSchema,
  component: function InstagramCallbackRoute() {
    const { status, reason, store_id, username } = Route.useSearch();
    return (
      <InstagramCallbackPage
        status={status}
        reason={reason}
        storeId={store_id}
        username={username}
      />
    );
  },
});
